<template>
  <div class="login-bg">
    <div class="login-container">
      <div class="login-left">
        <div class="slogan">
          <div class="title-main">交易<br><span>高雅的艺术</span></div>
          <!-- <div class="desc">
            龟谷是一家以跨市场洞察驱动为核心的金融科技服务公司<br>
            通过国际化视野与多元化投资策略结合<br>
            为投资者提供专业、系统的课程及培训服务<br>
            助力个人和机构提升金融素养，实现财富管理的科学化、专业化和智能化
          </div> -->
          <div class="copyright">
            Copyright 2012--2025 whhgfx.com版权所有 黔ICP备2025056779号<br>
            黔ICP备2025056779号隐私声明资质证照网站支持IPv6
          </div>
        </div>
      </div>
      <div class="login-right">
        <div class="login-box">
          <div class="login-title">
            <img src="@/assets/logo.png" alt="logo" class="logo-img" />
            欢迎注册龟谷论坛
          </div>
          <div class="login-form">
            <div class="input-wrapper">
              <img src="@/assets/account.png" class="input-icon" alt="user">
              <input class="input" type="text" placeholder="请输入账号" v-model="username" />
            </div>
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="lock">
              <input class="input" type="password" placeholder="请输入密码" v-model="password" />
            </div>
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="lock">
              <input class="input" type="password" placeholder="请再次输入密码" v-model="confirmPassword" />
            </div>
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="phone">
              <input class="input" type="phone" placeholder="请输入手机号" v-model="phone" />
            </div>
            <div class="form-row">
              <label class="checkbox">
                <input type="checkbox" v-model="checked" />
                <span>我已阅读并同意《用户协议》和《隐私政策》</span>
              </label>
            </div>
            <button class="login-btn" :disabled="!canRegister" id="register-btn" @click="handleRegister">立即注册</button>
          </div>
          <div class="login-links">
            已有账号？<router-link to="/login">去登录</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-dialog
    v-model="dialogVisible"
    title=""
    width="700px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
    class="success-dialog"
  >
    <div class="dialog-content">
      <div class="success-icon">
        <el-icon size="48" color="#67c23a">
          <Check />
        </el-icon>
      </div>
      <div class="dialog-message">
        <h3>恭喜您注册成功！</h3>
        <p>是否立即登录您的账户？</p>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">稍后登录</el-button>
        <el-button type="primary" @click="loginPage" size="large">立即登录</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, defineOptions } from 'vue'
import { register } from '@/api/login'
import { ElMessage } from 'element-plus'
import { Check } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
const router = useRouter()
defineOptions({ name: 'RegisterPage' })
          
const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const phone = ref('')
const checked = ref(false)
const dialogVisible=ref(false)

const canRegister = computed(() => {
  return (
    username.value &&
    password.value &&
    confirmPassword.value &&
    password.value === confirmPassword.value &&
    phone.value &&
    /^1[3-9]\d{9}$/.test(phone.value) &&
    checked.value
  )
})

function handleRegister() {
  
  if (!checked.value) {
      ElMessage.warning('请先阅读并同意《用户协议》和《隐私政策》')
    return;
  }
  register(username.value, password.value, phone.value, '','').then(res => {
    // ElMessage.error('Oops, this is a error message.') 
    console.log(res)
    if (res && res.code === 200) {
      
      console.log(res)
      // ElMessage.success('注册成功')
      dialogVisible.value=true

      // 这里可以加跳转逻辑

    } else {
      ElMessage.error(res?.msg || '注册失败')
    }
  }).catch(err => {
    ElMessage.error('注册失败')
    console.error(err)
  })
}
function loginPage(){
  dialogVisible.value=false
  router.push('/login')
}
</script>

<style scoped>
.login-bg {
  height: 100vh; 
  min-height: 100vh;
  background: url('~@/assets/regist-login.png') no-repeat center center !important;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-left {
  flex: 1.2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 420px;
  height: 100vh;
}
.slogan {
  margin-right: 60px;
  max-width: 420px;
}
.title-main {
  font-size: 2.8rem;
  font-weight: 700;
  color: #258aff;
  line-height: 1.2;
  margin-bottom: 18px;
}
.title-main span {
  color: #258aff;
}
.desc {
  color: #444;
  font-size: 1.08rem;
  margin-bottom: 32px;
  line-height: 1.7;
}
.copyright {
  color: #bbb;
  font-size: 12px;
  margin-top: 40px;
}
.login-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 420px;
  height: 100vh;
}
.login-box {
  width: 380px;
  margin-left: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 32px rgba(0,64,255,0.08);
  padding: 38px 36px 28px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.logo-img {
  width: 40px;
  height: 40px;
  filter: brightness(0) saturate(100%) invert(27%) sepia(96%) saturate(7500%) hue-rotate(212deg) brightness(102%) contrast(101%);
  object-fit: contain;
}
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 10px;
}
.input {
  width: 100%;
  padding: 10px 12px;
  /* border: 1.2px solid #e6e6e6; */
  border-radius: 6px;
  font-size: 15px;
  outline: none;
  transition: border 0.2s;
}
.input:focus {
  border: 1.2px solid #258aff;
}
.form-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.checkbox {
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
}
.login-btn {
  width: 100%;
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 6px;
  transition: background 0.2s;
}
.login-btn:disabled {
  background: #b3d6ff;
  cursor: not-allowed;
}
.login-links {
  width: 100%;
  text-align: center;
  margin-top: 12px;
  color: #888;
  font-size: 14px;
}
.login-links a, .login-links .router-link-active {
  color: #258aff;
  text-decoration: none;
  margin: 0 4px;
}
.input-wrapper {
  display: flex;
  align-items: center;
  background: #fafbfc;         /* 浅灰色背景 */
  border: 1px solid #f0f0f0;   /* 浅灰色边框 */
  border-radius: 4px;
  padding: 0 12px;
  margin-bottom: 18px;
  height: 44px;                /* 统一高度 */
  transition: border 0.2s;
}
.input-wrapper:focus-within {
  border: 1px solid #b3b3b3;   /* 聚焦时边框变深 */
}
.input-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  opacity: 0.6;                /* 图标淡一点 */
}
.input-wrapper input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 15px;
  color: #333;
  padding: 10px 0;
}
.input-wrapper input::placeholder {
  color: #b3b3b3;
  font-size: 15px;
}
@media (max-width: 900px) {
  .login-left {
    display: none;
  }
  .login-right {
    flex: 1;
    justify-content: center;
    min-width: 0;
  }
  .login-box {
    margin: 0;
  }
}
@media (max-width: 500px) {
  .login-box {
    width: 98vw;
    padding: 18px 2vw 18px 2vw;
  }
}

/* Dialog 样式优化 */
.success-dialog {
  border-radius: 12px;
}

.success-dialog :deep(.el-dialog) {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.success-dialog :deep(.el-dialog__header) {
  padding: 24px 24px 0 24px;
  border-bottom: none;
}

.success-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.success-dialog :deep(.el-dialog__body) {
  padding: 20px 24px;
}

.success-dialog :deep(.el-dialog__footer) {
  padding: 0 24px 24px 24px;
  border-top: none;
}

.dialog-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  margin-bottom: 16px;
}

.success-icon {
  margin-bottom: 16px;
}

.dialog-message h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.dialog-message p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.dialog-footer .el-button {
  min-width: 100px;
  border-radius: 6px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .success-dialog :deep(.el-dialog) {
    width: 90% !important;
    margin: 0 auto;
  }
  
  .dialog-footer {
    flex-direction: column;
    gap: 8px;
  }
  
  .dialog-footer .el-button {
    width: 100%;
  }
}
</style> 